import React from "react";
import { Gift } from "lucide-react";
import AssetFamilyPanel from "../components/AssetFamilyPanel";
import { SIX_STATE_STATUS_VALUES } from "../components/StatusSelectField";
import { createOffer, createOfferVersion, getOffers, updateOfferMetadata } from "../../../lib/emailMarketingApi";

// EMAILS-IMPL-009: Offers authoring (OFF-SPEC-001).
const config = {
  familyCode: "OFF",
  testIdPrefix: "offers",
  idField: "offer_id",
  contentField: "canonical_offer",
  contentLabel: "Canonical Offer",
  contentInputType: "textarea",
  contentPlaceholder: "e.g. $100,000 in coverage starting at $9/month.",
  labelSingular: "Offer",
  labelPlural: "Offers",
  icon: Gift,
  statusValues: SIX_STATE_STATUS_VALUES,
  createDescription: "A governed, reusable offer (OFF####).",
  api: {
    list: getOffers,
    create: ({ name, status, content }) => createOffer({ name, status, canonicalOffer: content }),
    createVersion: (id, { version, content }) => createOfferVersion(id, { version, canonicalOffer: content }),
    updateMetadata: (id, { name, status }) => updateOfferMetadata(id, { name, status }),
  },
};

export default function OffersPanel() {
  return <AssetFamilyPanel config={config} />;
}
